"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _convertArrayToObject = _interopRequireDefault(require("./convertArrayToObject"));

var _default = function _default() {
  var cache = null;
  var previousArray = null;
  return function (array) {
    if (previousArray !== array) {
      previousArray = array;
      cache = (0, _convertArrayToObject.default)(array);
    }

    return cache;
  };
};

exports.default = _default;
module.exports = exports.default;